// 临期预警table
export const AdventTableColumns = [
  {
    title: '仓库',
    dataIndex: 'warehouse_name',
    key: 'warehouse_name',
    ellipsis: true,
    scopedSlots: { customRender: 'warehouse_name' },
    width: 200,
  },
  {
    title: '货主',
    dataIndex: 'shipper_name',
    key: 'shipper_name',
    ellipsis: true,
    scopedSlots: { customRender: 'shipper_name' },
    width: 200,
  },
  {
    title: '货品名称',
    dataIndex: 'goods_name',
    key: 'goods_name',
    ellipsis: true,
    scopedSlots: { customRender: 'goods_name' },
    width: 200,
  },
  {
    title: '温层',
    dataIndex: 'temperature_layer',
    key: 'temperature_layer',
    width: 200,
  },
  {
    title: '批次号',
    dataIndex: 'batch_no',
    key: 'batch_no',
    width: 200,
  },
  {
    title: '生产日期',
    dataIndex: 'product_date',
    key: 'product_date',
    customRender: (text, record) => record.product_date,
    width: 200,
  },
  {
    title: '临保质日',
    dataIndex: 'tshelf_date',
    key: 'tshelf_date',
    customRender: (text, record) => record.tshelf_date,
    width: 200,
  },
  {
    title: '过期日期',
    dataIndex: 'expire_date',
    key: 'expire_date',
    customRender: (text, record) => record.expire_date,
    width: 200,
  },
  {
    title: '保质天数',
    dataIndex: 'sys_shelflife_days',
    key: 'sys_shelflife_days',
    width: 180,
  },
  {
    title: '收货标签号',
    dataIndex: 'pallet_code',
    key: 'pallet_code',
    width: 180,
  },
  {
    title: '整单位换算率',
    dataIndex: 'conversion_rate',
    key: 'conversion_rate',
    width: 180,
  },
  {
    title: '临期库存量',
    dataIndex: 'near_odue_amount_total',
    key: 'near_odue_amount_total',
    customRender: (text, record) => record.near_odue_amount_total?`${record.near_odue_amount_total}${record.default_unit}`:'--',
    width: 180,
    fixed:'right',
  },
  {
    title: '临期库存量(整单位)',
    dataIndex: 'near_big_odue_amount_total',
    key: 'near_big_odue_amount_total',
    customRender: (text, record) => record.near_big_odue_amount_total?`${record.near_big_odue_amount_total}${record.big_unit}`:'--',
    width: 180,
    fixed:'right',
  },
]

// 超期预警table
export const ExtendedTableColumns = [
  {
    title: '仓库',
    dataIndex: 'warehouse_name',
    key: 'warehouse_name',
    ellipsis: true,
    scopedSlots: { customRender: 'warehouse_name' },
    width: 200,
  },
  {
    title: '货主',
    dataIndex: 'shipper_name',
    key: 'shipper_name',
    ellipsis: true,
    scopedSlots: { customRender: 'shipper_name' },
    width: 200,
  },
  {
    title: '货品名称',
    dataIndex: 'goods_name',
    key: 'goods_name',
    ellipsis: true,
    scopedSlots: { customRender: 'goods_name' },
    width: 200,
  },
  {
    title: '温层',
    dataIndex: 'temperature_layer',
    key: 'temperature_layer',
    width: 200,
  },
  {
    title: '批次号',
    dataIndex: 'batch_no',
    key: 'batch_no',
    width: 200,
  },
  {
    title: '生产日期',
    dataIndex: 'product_date',
    key: 'product_date',
    customRender: (text, record) => record.product_date,
    width: 200,
  },
  {
    title: '临保质日',
    dataIndex: 'tshelf_date',
    key: 'tshelf_date',
    customRender: (text, record) => record.tshelf_date,
    width: 200,
  },
  {
    title: '过期日期',
    dataIndex: 'expire_date',
    key: 'expire_date',
    customRender: (text, record) => record.expire_date,
    width: 200,
  },
  {
    title: '保质天数',
    dataIndex: 'sys_shelflife_days',
    key: 'sys_shelflife_days',
    width: 180,
  },
  {
    title: '收货标签号',
    dataIndex: 'pallet_code',
    key: 'pallet_code',
    width: 180,
  },
  {
    title: '整单位换算率',
    dataIndex: 'conversion_rate',
    key: 'conversion_rate',
    width: 180,
  },
  {
    title: '超期库存量',
    dataIndex: 'odue_amount_total',
    key: 'odue_amount_total',
    customRender: (text, record) => record.odue_amount_total?`${record.odue_amount_total}${record.default_unit}`:'--',
    width: 180,
    fixed:'right',
  },
  {
    title: '超期库存量(整单位)',
    dataIndex: 'odue_big_amount_total',
    key: 'odue_big_amount_total',
    customRender: (text, record) => record.odue_big_amount_total?`${record.odue_big_amount_total}${record.big_unit}`:'--',
    width: 180,
    fixed:'right',
  },
]

// 费目明细table配置
export const costBreakdownColumns = [
  {
    title: '序号',
    key: 'index',
    dataIndex: 'index',
    scopedSlots: { customRender: "index" },
    width:80,
  },
  {
    title: '费目名称',
    dataIndex: 'costCode',
    key: 'costCode',
  },
  {
    title: '应付金额(元)',
    dataIndex: 'billValue',
    key: 'billValue',
  },
]
// 临期预警
export const AdventSearchFiled= [
  {
    label:'仓库',
    name:'warehouseCode',
    custom:true
  },
]

// 超期预警
export const ExtendedSearchFiled= [
  {
    label:'仓库',
    name:'warehouseCode',
    custom:true
  },
]
